const BusinessIcon = ({
  width,
  height,
}: {
  width?: number
  height?: number
}) => {
  return (
    <svg
      width={width || "40"}
      height={height || "40"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-labelledby="business-icon"
    >
      <title id="business-icon" />
      <g clipPath="url(#clip0_3316_46670)">
        <path
          d="M20.0201 39.9851C29.2341 39.9851 36.7035 39.2201 36.7035 38.2765C36.7035 37.3329 29.2341 36.568 20.0201 36.568C10.8061 36.568 3.33667 37.3329 3.33667 38.2765C3.33667 39.2201 10.8061 39.9851 20.0201 39.9851Z"
          fill="#F1F1F1"
        />
        <path
          d="M24.8291 1.33686C26.6834 1.33686 28.1909 9.19114 28.1909 18.8796H30.8794C30.8794 8.44239 28.1708 -0.0148926 24.8291 -0.0148926C22.9296 -0.0148926 21.2311 2.52782 20.1256 6.5027C19.015 2.52782 17.3216 -0.0148926 15.4221 -0.0148926C12.0804 -0.0148926 9.37183 8.44239 9.37183 18.8796H12.0603C12.0603 9.19114 13.5628 1.33686 15.4221 1.33686C17.2814 1.33686 18.7839 8.58812 18.7839 17.5328H21.4723C21.4673 8.58812 22.9698 1.33686 24.8291 1.33686Z"
          fill="#FFBC0D"
        />
        <path
          d="M18.01 23.3017H22.0301V37.7841C22.0301 37.7841 22.0301 38.5781 20.0201 38.5781C18.01 38.5781 18.01 37.7841 18.01 37.7841V23.3017Z"
          fill="#ADADAD"
        />
        <path
          d="M22.0301 23.3017H18.01V26.5178H22.0301V23.3017Z"
          fill="black"
        />
        <path
          d="M6.06028 16.0806C5.9447 15.769 6.10048 15.4223 6.41204 15.3017C6.48239 15.2765 6.55274 15.2615 6.62309 15.2615H33.4221C33.7537 15.2615 34.0251 15.5328 34.0251 15.8645C34.0251 15.9348 34.01 16.0102 33.9849 16.0755L31.8643 21.7037C31.7738 21.9399 31.5527 22.0956 31.3015 22.0956H8.74369C8.49244 22.0956 8.26631 21.9399 8.18088 21.7037L6.06028 16.0806Z"
          fill="#DB0007"
        />
      </g>
      <defs>
        <clipPath id="clip0_3316_46670">
          <rect
            width="33.3668"
            height="40"
            fill="white"
            transform="translate(3.31659)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BusinessIcon
